<template>
  <tr>
    <td :colspan="this.headers_length">
      <div class="flex-row cursor-pointer">

        <!-- C2C THUMBNAIL -->
        <Thumbnail :thumbnailURL="this.part.thumbnailURL" :hasC2C="this.part.hasC2C"
          :style="{ flex: '0 0 var(--header-thumbnail-width)' }" @click.native.stop="show_c2c" />

        <!-- INFO -->
        <InfoRow :part="this.part" :grouped_by="this.grouped_by" />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    headers_length: {
      type: Number,
      required: true
    },
    group_name: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    part: {
      type: Object,
      required: true
    },
    grouped_by: {
      type: String,
      required: true
    },
    disable_select_action: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      thumbnail_abort_controller: null,
      stoHandler: null,
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    }),
  },
  components: {
    Thumbnail: () => import('../../Thumbnail'),
    InfoRow: () => import('./InfoRow.desktop')
  },
  methods: {
    ...mapActions({
      GET_THUMBNAIL: "parts/GET_THUMBNAIL",
      GET_C2C: "parts/GET_C2C",
      SET_C2C: "parts/SET_C2C",
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      TOGGLE_SPINNER: "spinner/TOGGLE_SPINNER"
    }),
    async show_c2c() {
      if (!this.part.hasC2C) return;

      await this.TOGGLE_SPINNER({ active: true });

      if (this.part.c2c)
        await this.SET_C2C(this.part);
      else
        await this.GET_C2C(this.part);

      await this.TOGGLE_MODAL_STATE({ name: 'graphicsUrl', value: true });
      await this.TOGGLE_SPINNER({ active: false });
    },
    async load_thumbnail() {
      if (this.part.thumbnailURL && this.part.thumbnailURL.includes("loading_thumbnail.gif")) {
        this.thumbnail_abort_controller = new AbortController();
        this.stoHandler = await this.GET_THUMBNAIL({ part: this.part, index: this.index, signal: this.thumbnail_abort_controller.signal });
      }
    }
  },
  async mounted() {
    await this.load_thumbnail();
  },
  beforeDestroy() {
    if (this.thumbnail_abort_controller)
      this.thumbnail_abort_controller.abort();

    if (this.stoHandler)
      clearTimeout(this.stoHandler);
  }
}
</script>

<style lang="stylus" scoped>
.part-hover:hover {
  background: #ccc !important;
}

ul{
  list-style: none;
  padding: 0;
}

.cursor-pointer:hover{
  background: var(--v-primary-base-hover);
}

:deep() .read-more{
  color: var(--primary-color)
}

:deep()
    p
     margin-bottom .5em

    .description-cell
      ul
        padding 0
      li
        display flex
        align-items flex-start

        &.additional-description-comment
          p
            opacity .65
          i
            display none
            opacity .25
        &.specific-condition-comment
          color: var(--v-warning-darken3)
          opacity 1
        &:last-of-type
          margin-bottom 1em
      i
        margin-top .08em
        margin-right .5em
        font-size 14px

  tr:hover + .extension-row
    background-color var(--v-secondary-lighten2)

  tr.extended[data-hover-active="true"]
    background-color var(--v-base-lighten2)


    p
     margin-bottom .7em

    .description-cell
      ul
        padding 0
      li
        display flex
        align-items flex-start

        &.additional-description-comment
          p
            opacity .65
          i
            display none
        &:last-of-type
          margin-bottom 1.1em

  /* Phone styles */
  @media( max-width: 750px)
    tr[active]
      background-color transparent

  @media screen and (min-width: 1904px)
    .description-cell
      padding-right: 100px !important

</style>